import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cec2e9ck5e: FaireBrandEntity = {
  token: "b_cec2e9ck5e",
  type: "brand",
  name: "Imported Brand Two",
  avatarUrl: "https://cdn.faire.com/fastly/example-brand-logo-2.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/example-brand-logo-2.jpeg",
  location: "United States",
  minimumOrderDollars: 100,
  rating: 4.7,
  description: "Second canonical imported brand entity.",
  meta: {
    source: "api",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
